import { render } from "./TaxesModal.vue?vue&type=template&id=6e353181&scoped=true"
import script from "./TaxesModal.vue?vue&type=script&lang=js"
export * from "./TaxesModal.vue?vue&type=script&lang=js"

import "./TaxesModal.vue?vue&type=style&index=0&id=6e353181&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e353181"]])

export default __exports__